import React, {Fragment} from 'react'
import Icon from "../Icon";
import {Transition} from "@headlessui/react";

// Types ----

type SelectedCardProps = {
  heading: string
  subheading?: string | null
  footer?: string | null
  imageUrl?: string
  onRemove?: () => void
  active?: boolean
}

// Component ----

function SelectedCard({heading, subheading, footer, imageUrl, onRemove}: SelectedCardProps) {

  return (
    <Transition
      as={Fragment}
      appear={true}
      enter="transition-[opacity] duration-500 transform-gpu"
      enterFrom="opacity-0"
      enterTo="opacity-100"
    >
      <div
        className={`flex gap-4 border border-gray-200 min-h-[3.5rem] rounded-md items-center overflow-hidden text-left flex-shrink-0`}
      >
        <div
          className='self-stretch w-[60px] sm:w-[80px] bg-gray-100 overflow-hidden flex-shrink-0 bg-cover bg-no-repeat'
          style={{backgroundImage: `url(${imageUrl})`}}
        />

        <div className="flex flex-col min-w-0 gap-1.5 py-2">
          <p className="text-sm text-gray-900 truncate">{heading}</p>
          {subheading && <p className="text-sm text-gray-500 truncate">{subheading}</p>}
          {footer && <p className="text-xs text-gray-400 truncate tracking-wider">{footer}</p>}
        </div>

        {!!onRemove &&
          <button onClick={onRemove} className="flex ml-auto shrink-0 p-2" type='button' title='Remove'>
            <span className='sr-only'>Remove</span>
            <Icon name='x' className='text-gray-500 size-5' />
          </button>
        }
      </div>
    </Transition>

  );
}

export {SelectedCard};